import { Link } from 'foundations-components/transitional/components/Link';
import trackedProp from './trackedProp';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackedLink = trackedProp(Link, 'onClick');
export const TrackedLinkNoPropagation = props => {
  const PureTrackedLink = trackedProp(Link, 'onClick');
  return /*#__PURE__*/_jsx(PureTrackedLink, Object.assign({}, props, {
    onClick: e => {
      var _props$onClick;
      e.stopPropagation();
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, e);
    }
  }));
};